// extracted by mini-css-extract-plugin
export var cardLayout = "_69-1";
export var paginationContainer = "_69-0";